<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="m12.02 12.58 8.57-3.67 2.28 3.17-7.83 3.71-3.02-3.21zM12.22 5.67 9.39 2.43 1.13 5.67l2.44 3.4 8.65-3.4zM14.57 2.43l8.28 3.24-2.26 3.24-8.37-3.24 2.35-3.24z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="m9.15 15.79 2.87-3.21-8.45-3.51-2.44 3.12 8.02 3.6zM12.22 5.67l.1 17.13 8.37-3.39v-6.3"
    />
    <path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M3.41 12.87v6.54l8.91 3.39" />
    <path fill="none" d="m10.92 23.07 2.01.67-.5.26H9.97l.95-.93z" />
  </svg>
</template>
